var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2168 0.949707C4.64744 0.949707 0.123047 5.46816 0.123047 11.0435C0.123047 16.6188 4.64744 21.1373 10.2168 21.1373C15.7922 21.1373 20.3106 16.6188 20.3106 11.0435C20.3106 5.46816 15.7922 0.949707 10.2168 0.949707ZM7.83589 17.8716C6.92151 17.8716 6.33369 16.8088 6.33369 15.7638C6.33369 13.5254 9.19558 8.90599 10.1278 8.52005C10.199 8.50223 10.3831 8.48442 10.6028 8.48442C11.06 8.48442 11.7012 8.57942 11.7012 8.88817C11.7012 8.9238 11.6834 8.98317 11.6478 9.03661C11.2618 9.76693 8.51276 14.5704 8.51276 15.8351C8.51276 16.1082 8.62558 16.221 8.77402 16.221C9.90808 16.221 12.0159 12.7535 12.1822 12.7535C12.384 12.7535 12.4018 13.1751 12.4018 13.4363C12.4018 13.7629 9.74183 17.8716 7.83589 17.8716ZM12.3247 7.40379C11.4637 7.40379 10.7156 6.78035 10.7156 5.9016C10.7156 4.94566 11.5765 4.21534 12.4909 4.21534C13.3518 4.21534 14.1059 4.83878 14.1059 5.71754C14.1059 6.67348 13.245 7.40379 12.3247 7.40379Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.5c692bc0.svg";
export { ForwardRef as ReactComponent };